var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['messageContainer', _vm.isCard && 'messageContainer--inCard']},[_c('span',{staticClass:"cardNew__title"},[_vm._v("Mensaje")]),_c('p',{staticClass:"cardNew__message"},[_vm._v(_vm._s(_vm.message || "Sin mensaje"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }